import userName from '@utils/user/userName'
import friendlyDate from '@utils/date/friendlyDate'
import substituteLinks from '@utils/links/substituteLinks'
import useT from '@hooks/useTranslation'

import styles from '@components/chat/styles/ListItemMessage.module.css'

const Message = ({ _from, _to, text: message, created, userId, chat }) => {
    const isBulk = _from === undefined && _to === undefined
    const isSystem = _from === null
    const isOneWay = isBulk || isSystem

    const received = isOneWay
        ? true
        : userIdsAreEqual(userId, _to)

    const otherUser = isOneWay
        ? null
        : userIdsAreEqual(userId, _from)
            ? chat._to
            : chat._from

    const text = {
        systemowa: useT('Wiadomość Systemowa'),
        ty: useT('Ty'),
    }

    const otherMessageCaption = isOneWay
        ? text.systemowa
        : userName(otherUser)

    return (
        <div className={received
            ? styles.received
            : styles.sent}>

            <div className={styles.info}>
                <span className={styles.date}>{friendlyDate(created, useT)}</span>
                <span className={styles.who}>{received
                    ? otherMessageCaption
                    : text.ty}</span>
            </div>
            <div className={styles.text}>{substituteLinks(message)}</div>
        </div>
    )
}

function userIdsAreEqual (idOne, idTwo) {
    return String(idOne) === String(idTwo)
}

export default Message